import React from "react";
import { OpenNavigation } from "./styles";

export default function NavigationMobile({ open, setOpen }) {
  return (
    <OpenNavigation open={open} onClick={setOpen}>
      <span />
      <span />
      <span />
    </OpenNavigation>
  );
}
